<template>
  <div class="card-ficha-cadastral">
    <PDialog
      v-model:visible="exibeMensagemAviso"
      :closable="false"
      class="gama-popup-simples"
    >
      <div class="popup-mensagem-aviso">
        <div class="mensagem-aviso">{{ mensagemDeAviso }}</div>
        <g-button
          tipo="amarelo"
          class="botao-aviso"
          @click="exibeMensagemAvisoPopup"
          negritoTexto
        >
          OK
        </g-button>
      </div>
    </PDialog>

    <g-card :expansivel="false" :temCabecalho="false">
      <div class="cabecalho-formulario">
        <div class="titulo-formulario titulo-ficha-cadastral"> Ficha Cadastral </div>
      </div>

      <g-form>
        <div class="conteudo-clientes-ficha-cadastral espacamento-filtros">
          <div class="titulo-grupo-formulario"> Dados Cadastrais </div>
          <div class="grupo-dados-cadastrais">
            <div class="dados-unidade">
              <div class="titulo-conteudo-filtros"> Unidade <strong class="asterisco-obrigatorio">*</strong></div>              
              <div>
                <PDropDown 
                v-model="EmpresaSelecionada"
                :class="`input ${v$.EmpresaSelecionada.$invalid && submit ? 'p-invalid' : '' }`"
                @change="verificarAlteracaoListaEmpresa"
                :options="EmpresaArray"
                optionLabel="nome"
                optionValue="id"
                placeholder="Selecione"
                :filter="true"
                >
                </PDropDown>
                <div class="checkbox-filtros checkbox-exterior-ie">
                  <div class="exterior-input input-checkbox">
                    <PCheckBox 
                    name="extr"
                    value="exterior-value"
                    :binary="true"
                    @change="cidades_exterior"
                    @click="cnpjExterior"
                    :disabled="modoEdicao" 
                    v-model="checkboxExt"
                    ></PCheckBox>
                    <label class="exterior label-checkbox" for="extr" > Exterior </label>
                  </div>
                  <div class="input-checkbox">
                    <PCheckBox 
                    name="ie-is"
                    value="isento"
                    :binary="true"
                    @click="inscricaoIsento"
                    :disabled="modoEdicao"
                    v-model="ieIsento"
                    ></PCheckBox>
                    <label class="ieIsento label-checkbox" for="ie-isento" > IE - Isento </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="dados-cnpj">
              <div class="titulo-conteudo-filtros"> CNPJ <strong class="asterisco-obrigatorio">*</strong></div>              
              <div style="display: flex; gap: 1rem; align-items: center;">
                <PInputText 
                v-if="!checkboxExt"
                placeholder="Insira o CNPJ do cliente"
                :class="`input ${v$.cnpj.$invalid && submit ? 'p-invalid' : '' }`"
                v-mask= "'##.###.###/####-##'"
                :disabled="EmpresaSelecionada == null || checkboxExt || modoEdicao"
                v-model="cnpj"
                v-on:blur="conferecnpjAPIExiste"

                />

                <PInputText 
                v-else
                placeholder="Insira o CNPJ do cliente"
                :class="`input ${v$.cnpj.$invalid && submit ? 'p-invalid' : '' }`"
                v-mask= "'###.###.###/####-##'"
                :disabled="EmpresaSelecionada == null || checkboxExt || modoEdicao"
                v-model="cnpj"
                v-on:blur="conferecnpjAPIExiste"
                />
                
                <g-button
                class="buscar-button"
                largura="32px"
                icone="icone_lupa.svg"
                negritoTexto
                tamanhoIcone="13px"
                tamanhoTexto="12px"
                altura="32px"
                :somenteIcone="true"
                :sombreado="false"
                @click="verificaCPNJ"
                v-tooltip="'Busca informações do cliente no SINTEGRA'"
                >
                </g-button>
              </div>
                    
            </div>

            <div class="dados-inscricao">
              <div class="titulo-conteudo-filtros"> Inscrição Estadual <strong v-if="!ieIsento" class="asterisco-obrigatorio">*</strong></div>              
              <PInputText 
              :class="`input ${v$.inscricaoEstadual.$invalid && submit ? 'p-invalid' : '' }`"
              id="InscricaoEstadual"
              placeholder="Insira uma Inscrição Estadual"
              maxlength="19"
              :disabled="this.desabilitarInscricaoEstadual || ieIsento"
              v-model="inscricaoEstadual"
              ></PInputText>
            </div>

            <div class="dados-razao-social">
              <div class="titulo-conteudo-filtros"> Razão Social <strong class="asterisco-obrigatorio">*</strong></div>              
              <PInputText 
              :class="`input ${v$.razaoSocial.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Insira a Razão Social do cliente"
              maxlength="50"
              v-model="razaoSocial"
              ></PInputText>
            </div>

            <div class="dados-nome-fantasia">
              <div class="titulo-conteudo-filtros"> Nome Fantasia <strong class="asterisco-obrigatorio">*</strong></div>              
              <PInputText 
              :class="`input ${v$.nomeFantasia.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Insira o nome fantasia"
              maxlength="20"
              v-model="nomeFantasia"
              ></PInputText>
            </div>

            <div class="dados-segmento">
              <div class="titulo-conteudo-filtros"> Segmento <strong class="asterisco-obrigatorio">*</strong></div>              
              <PDropDown 
              :class="`input ${v$.SegmentoSelecionado.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Selecione"
              :options="SegmentoArray"
              optionLabel="descricao"
              optionValue="clienteTipoId"
              v-model="SegmentoSelecionado"
              ></PDropDown>
            </div>

            <div class="dados-curva-cliente">
              <div class="titulo-conteudo-filtros"> CV </div>      
              <PInputText 
              class="input"
              type="int"
              placeholder="" 
              maxlength="5"
              disabled
              v-model="codigo"
              ></PInputText>        
            </div>

            <div class="dados-potencial-cliente">
              <div class="titulo-conteudo-filtros"> Potencial do Cliente <strong class="asterisco-obrigatorio">*</strong></div>              
              <PDropDown 
              :class="`input ${v$.PotencialSelecionado.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Selecione"
              :options="PotencialArray"
              optionLabel="text"
              optionValue="value"
              v-model="PotencialSelecionado"
              >
              </PDropDown>
            </div>

            <div class="dados-perfil-material">
              <div class="titulo-conteudo-filtros"> Perfil Material<strong class="asterisco-obrigatorio">*</strong></div>              
              <PDropDown 
              :class="`input ${v$.PerfilMaterialSelecionado.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Selecione"
              :options="PerfilMaterialArray"
              optionLabel="text"
              optionValue="value"
              v-model="PerfilMaterialSelecionado"
              ></PDropDown>
            </div>

            <div class="dados-cep">
              <div class="titulo-conteudo-filtros"> CEP <strong class="asterisco-obrigatorio">*</strong></div>   
              <div style="display: flex; gap: 1rem; align-items: center;">
              <PInputMask 
              :class="`input ${v$.cep.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="CEP"
              mask="99999-999"
              :disabled="this.desabilitarcep"
              v-model="cep"
              ></PInputMask>    
              
              <!-- <g-button
              class="buscar-button"
              largura="32px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="13px"
              tamanhoTexto="12px"
              altura="32px"
              :somenteIcone="true"
              :sombreado="false"
              @click="buscarCep"
              v-tooltip="'Busca cidade, estado e endereço no VIACEP'"

              >
              </g-button> -->
            </div>
          </div>

            <div class="dados-endereco">
              <div class="titulo-conteudo-filtros"> Endereço <strong class="asterisco-obrigatorio">*</strong></div>      
              <PInputText 
              :class="`input ${v$.endereco.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="Insira o endereço do cliente"
              maxlength="40"
              v-model="endereco"
              ></PInputText>        
            </div>

            <div class="dados-complemento">
              <div class="titulo-conteudo-filtros"> Complemento </div>      
              <PInputText 
              class="input"
              placeholder="Insira um complemento de endereço"
              maxlength="25"
              v-model="complemento"
              ></PInputText>        
            </div>

            <div class="dados-bairro">
              <div class="titulo-conteudo-filtros"> Bairro <strong class="asterisco-obrigatorio">*</strong></div>      
              <PInputText 
              :class="`input ${v$.bairro.$invalid && submit ? 'p-invalid' : '' }`"
              class="input"
              placeholder="Insira o Bairro"
              maxlength="25"
              v-model="bairro"
              ></PInputText>        
            </div>

            <div class="dados-estado">
              <div class="titulo-conteudo-filtros"> Estado<strong class="asterisco-obrigatorio">*</strong></div>              
              <PDropDown
              :filter="true"
              placeholder="Selecione"
              @change="buscarcidade"
              :options="EstadoArray"
              optionLabel="siglaEstado"
              optionValue="id"
              :disabled="DesativaEstado"
              v-model="EstadoSelecionado"
              >
                <template v-if="EdicaoBack" #value>
                  {{ ufValue}}
                </template>
              </PDropDown>
            </div>

            <div class="dados-cidade">
              <div class="titulo-conteudo-filtros"> Cidade<strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown
              placeholder="Selecione"
              :filter="true"
              @filter="buscarCidadeSemEstado($event.value)"
              @change="setCidade"
              :options="CidadeArray"
              optionLabel="nomeCidade"
              optionValue="id"
              :disabled="DesativaCidade"
              v-model="CidadeSelecionada"
              >
                <template v-if="EdicaoBack" #value>
                  {{ cidadeValue }}
                </template>
              </PDropDown>
            </div>       
            
            
            <div class="dados-telefone-celular">
              <div class="titulo-conteudo-filtros"> Telefone/Celular <strong class="asterisco-obrigatorio">*</strong></div>
              <!-- {{this.objCliente.telefone }} -->
              <!-- <InputClienteTelefone :clienteId="$store.state.cliente.id" v-model="objCliente.telefone" @invalido="telefoneCelularInvalido = $event"/> -->
              <PInputText
              :class="`input ${v$.telefonecelular.$invalid && submit ? 'p-invalid' : '' }`"
              v-model="telefonecelular"
              placeholder="(99) 99999-9999"
              @keypress="camponumero"
              maxlength="12"
              autoFocus
            />
            </div>

            <div class="dados-incentivos">
              <div class="parametros-titulo titulo-conteudo-filtros"> Possui incentivo fiscal - Diferimento? </div>
              <div class="checkbox-filtros">
                <div class="incentivo-icms input-checkbox">
                  <PCheckBox 
                  id="incentivo-icms" 
                  class="checkbox-incentivo-icms"
                  name="Icms"
                  value="dado"
                  v-model="CheckIncentivoFiscal"
                  :disabled="modoEdicao"
                  :binary="true"
                  ></PCheckBox>
                  <label class="incentivoIcms label-checkbox" for="incentivo-icms" > ICMS </label>
                </div>
                
                <div class="incentivo-pis input-checkbox">
                  <PCheckBox 
                  id="incentivo-pis" 
                  class="checkbox-incentivo-pis"
                  name="PsCo"
                  value="dado"
                  :binary="true"
                  :disabled="modoEdicao"
                  v-model="CheckPIS"
                  ></PCheckBox>
                  <label class="incentivoPis label-checkbox" for="incentivo-pis" > PIS / COFINS </label>
                </div>

                <div class="incentivo-ipi input-checkbox">
                  <PCheckBox 
                  id="incentivo-ipi" 
                  class="checkbox-incentivo-ipi"
                  name="Ipi"
                  value="dado"
                  :binary="true"
                  :disabled="modoEdicao"
                  v-model="CheckIPI"
                  ></PCheckBox>
                  <label class="incentivoIpi label-checkbox" for="incentivo-ipi" > IPI </label>
                </div>
              </div>
            </div>

            <!-- <div class="dados-email">
              <div class="titulo-conteudo-filtros"> E-mail de envio NFE </div>      
              <PInputText 
              :class="`input ${v$.EmailNFE.$invalid && submit ? 'p-invalid' : '' }`"
              placeholder="E-mail"
              ref="emailnfe"
              :disabled="this.desabilitarEmailNFE"
              v-model="EmailNFE"
              maxlength="60"
              ></PInputText>        
            </div> -->

            <div class="dados-suframa-inscricao">
              <div class="dados-suframa" v-if="exibeSuframa"> 
                <div class="titulo-conteudo-filtros"> Possui suframa? <strong class="asterisco-obrigatorio">*</strong></div>              
                <div class="buttons-suframa checkbox-filtros">
                  <div class="input-checkbox">
                    <PRadioButton class="espaçamento" name="suframa" value="sim" v-model="suframaSimNao"></PRadioButton>
                    <div class="label-checkbox"> Sim </div>
                  </div>
                  <div class="input-checkbox">
                    <PRadioButton class="espaçamento" name="suframa" value="nao" v-model="suframaSimNao"></PRadioButton>
                    <div class="label-checkbox"> Não </div>
                  </div>
                </div>
              </div>

              <div class="dados-inscricao-suframa" v-if="suframaSimNao">
                <div class="titulo-conteudo-filtros"> Inscrição Suframa <strong class="asterisco-obrigatorio">*</strong></div>              
                <PInputText
                type="text"
                v-model="numeroSuframa"
                @keypress="camponumero"
                maxlength="12"
                autoFocus
              />
              </div>
            </div>

            <div class="buttons-arquivos" v-if="CheckIncentivoFiscal == true || CheckPIS == true || CheckIPI == true">
              <g-button 
              v-if="CheckIncentivoFiscal == true"
              altura="35px"
              largura="200px" 
              negritoTexto 
              tamanhoTexto="15px"
              @click="abrirPopupICMS"
              >
                Adicionar Arq. ICMS
              </g-button>
              
              <PDialog :closable="true" v-model:visible="popupICMS" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo ICMS </div>
                </template>

                <g-file-upload :arquivoMultiplo="true" v-on:edit="ImageEdit" :imagemPdf="true" v-on:upload="uploadICMS"></g-file-upload>
                
                <div class="button-fechar-popup">
                  <g-button 
                  tipo="cinza" 
                  altura="35px"
                  largura="15em" 
                  negritoTexto 
                  tamanhoTexto="15px" 
                  @click="fechapopupICMS"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>
              
              <div id="popupImage">
                <PDialog v-model:visible="popupEditImage" class="popup-dev" style="width: 53vw; border-radius: 5%;">
                  <div class="infoBasicas-imagemProduto">
                    <div v-if="imageArray.length === 0" class="img-info-mobile"> NENHUMA IMAGEM DISPONÍVEL! </div>
                    <template v-else>
                      <div class="image-container">
                        <div v-for="(image, id) in imageArray" :key="id" class="image-wrapper">
                            <PImage
                              v-on:error="erro($event)"
                              :src="'data:image/png;base64,' + image.base64Arquivo"
                              :imageStyle="styleImg"
                              :preview="true"
                            />
                            <PButton style="width: 22em;" class="image-button" icon="pi pi-trash" @click="deleteImage(image.id)" text />
                        </div>
                      </div>  
                    </template>
                  </div>
                </PDialog>
              </div>

              <g-button 
              v-if="CheckPIS == true" 
              altura="35px"
              largura="200px" 
              negritoTexto 
              tamanhoTexto="15px"
              @click="abrirPopupPIS" 
              >
                Adicionar Arq. PIS/COFINS
              </g-button>
              
              <PDialog :closable="true" v-model:visible="popupPIS" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo PIS/COFINS </div>
                </template>

                <g-file-upload :arquivoMultiplo="true" v-on:edit="ImageEdit" :imagemPdf="true" v-on:upload="uploadPIS"></g-file-upload>
                
                <div class="button-fechar-popup">
                  <g-button 
                  tipo="cinza" 
                  altura="35px"
                  largura="15em" 
                  negritoTexto 
                  tamanhoTexto="15px" 
                  @click="fechapopupPIS"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>

              <g-button 
              v-if="CheckIPI == true" 
              altura="35px"
              largura="200px" 
              negritoTexto 
              tamanhoTexto="15px"
              @click="abrirPopupIPI"
              >
                Adicionar Arq. IPI 
              </g-button>
              
              <PDialog :closable="true" v-model:visible="popupIPI" :modal="true">
                <template #header>
                  <div class="titulo-detalhes-cabecalho"> Adicionar Arquivo IPI </div>
                </template>

                <g-file-upload :arquivoMultiplo="true" v-on:edit="ImageEdit" :imagemPdf="true" v-on:upload="uploadIPI"></g-file-upload>
                  
                <div class="button-fechar-popup">
                  <g-button 
                  tipo="cinza" 
                  altura="35px"
                  largura="15em" 
                  negritoTexto 
                  tamanhoTexto="15px" 
                  @click="fechapopupIPI"
                  >
                    FECHAR
                  </g-button>
                </div>
              </PDialog>
            </div>                        
          </div>
        </div>
      </g-form>

      <div class="grid-cliente-contato">
        <g-data-table
        TextoVazio="Nenhum Contato Encontrado"
        Titulo="Contatos"
        v-on:acaoAdicionar="popupadicionar"
        v-on:editar="editar"
        v-on:getlinha="getlinha"
        v-on:excluir="excluir"
        Adicionavel
        :colunas="Colunas"
        :valores="informacaocontato"
        :NumeroLinhas="8"
        :Filtros="Filtro"
        :Editavel="true"
        ></g-data-table>

        <PDialog class="gama-popup" :closable="true" v-model:visible="popupcontatos" :style="{ width: '60%' }" :modal="true">
          <template #header>
            <div class="titulo-formulario"> Adicionar Contato </div>
          </template>

          <div class="grupo-form-contato">
            <div class="popup-tipo-contato">
              <div class="titulo-conteudo-filtros"> Tipo de Contato<strong class="asterisco-obrigatorio">*</strong></div>
              <PDropDown 
              placeholder="Selecione"
              :filter="true" 
              :options="TipoContatoArray"
              optionLabel="text" 
              v-model="TipoContato" 
              ></PDropDown>
            </div>

            <div class="popup-nome-contato">
              <div class="titulo-conteudo-filtros"> Nome do contato <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputText 
              placeholder="Insira o nome do contato" 
              maxlength="30"
              v-model="NomeContato" 
              ></PInputText>
            </div>

            <div class="popup-funcao-contato">
              <div class="titulo-conteudo-filtros"> Função </div>
              <PInputText 
              placeholder="Insira a função do contato" 
              maxlength="20"
              v-model="NomeFuncao"
              ></PInputText>
            </div>

            <div class="popup-sequencia">
              <div class="titulo-conteudo-filtros"> Sequência </div>
              <PInputNumber 
              v-if="editando" 
              disabled 
              v-model="sequencia"               
              ></PInputNumber>
              <PInputNumber 
              v-else 
              disabled 
              v-model="proximaSequencia"
              ></PInputNumber>
            </div>

            <div class="linha1 linha-separacao"></div>

            <div class="popup-site">
              <div class="titulo-conteudo-filtros"> Site </div>
              <PInputText 
              placeholder="Site" 
              maxlength="40"
              v-model="ClienteSite" 
              ></PInputText>
            </div>

            <div class="popup-email">
              <div class="titulo-conteudo-filtros"> E-mail <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputText 
              ref="email"
              placeholder="E-mail" 
              maxlength="60"
              v-model="Email" 
              ></PInputText>
            </div>

            <div class="linha2 linha-separacao"></div>

            <div class="popup-telefone">
              <div class="titulo-conteudo-filtros"> Telefone <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputMask 
              mask="(99) 9999-9999" 
              v-model="NumeroTelefone"
              ></PInputMask>
            </div>

            <div class="popup-celular">
              <div class="titulo-conteudo-filtros"> Celular  <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputMask 
              mask="(99) 99999-9999" 
              v-model="NumeroCelular"
              ></PInputMask>
            </div>


            <div class="popup-telefone-exterior" v-if="this.checkboxExt === true">
              <div class="titulo-conteudo-filtros"> Telefone Exterior <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputMask 
              mask="+99 99 9999999999" 
              v-model="TelefoneExterior" 
              ></PInputMask>
            </div>

            <div class="popup-celular-exterior" v-if="this.checkboxExt === true">
              <div class="titulo-conteudo-filtros"> Celular Exterior <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputMask 
              mask="+99 99 9999999999"
              v-model="CelularExterior"
              ></PInputMask>
            </div>

            <div class="linha3 linha-separacao"></div>

            <div class="popup-exigencia-nota">
              <div class="titulo-conteudo-filtros"> Cliente possui alguma exigência na nota fiscal? </div>
              <div class="checkbox-filtros">
                <div class="input-checkbox">
                  <PCheckBox 
                  name="OrdComp"  
                  v-model="OrdemCompra" 
                  :binary="true"
                  ></PCheckBox>
                  <label class="label-checkbox"> Ordem de Compra </label>
                </div>
                
                <div class="input-checkbox">
                  <PCheckBox 
                  name="CodEspec" 
                  v-model="CodigoEspecifico"
                  :binary="true"
                  ></PCheckBox>
                  <label class="label-checkbox"> Código específico </label>
                </div>
              </div>
            </div>
          </div>

          <div class="botoes-popup button-popup-telefone">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto 
              largura="230px" 
              altura="35px" 
              @click="cancelarpopup"
              >
                CANCELAR
              </g-button>
            </div>

            <div>
              <g-button
              v-if="!editando"
              negritoTexto
              largura="230px" 
              altura="35px" 
              @click="AdicionarNaTabela"
              >
                ADICIONAR   
              </g-button>
            </div>

            <div>
              <g-button
              v-if= "editando === true"
              negritoTexto
              largura="230px" 
              altura="35px" 
              @click="editarBotao"
              >
                ATUALIZAR   
              </g-button>
            </div>
          </div>
        </PDialog>
      </div>

      <div class="espacamento-filtros">
        <div class="titulo-grupo-formulario"> Cliente Agrupador </div>
        <div class="grupo-dados-cliente-agrupador">
          
          <div class="dados-empresa-cliente">
            <div class="titulo-conteudo-filtros"> Unidade Agrupador</div>
            <PDropDown
                v-model="EmpresaAgrupador"
                @change="verificarAlteracaoListaEmpresa"
                :options="EmpresaAgrupadorArray"
                optionLabel="nome"
                optionValue="id"
                placeholder="Selecione"
                :filter="true"
            
                >
                </PDropDown>
          </div>

          <div class="dados-nome-cliente">
            <div class="titulo-conteudo-filtros"> Cliente </div>
            <PDropDown
            placeholder="Selecione o cliente"
            :filter="true"
            :options="ClientesArray"
            :filterFields="['razaoSocial','codigoExterno','nomeFantasia','situacao','estadoCidade','cnpj']"
            optionLabel="nomeFantasia"
            @filter="buscarClientes($event.value)"
            @change="setCodigoExternoEmpresa"
            :disabled = "this.EmpresaAgrupador == null"
            v-model="nomeClienteAgrupador"
            >
              <template #option="slotProps">
                <cliente-dropdown-item :dadosCliente="slotProps.option"></cliente-dropdown-item>
              </template>
            </PDropDown>
          </div>

          <div v-if="nomeClienteAgrupador" class="dados-codigo-cliente">
            <div class="titulo-conteudo-filtros"> Código </div>
            <PInputText
            disabled
            v-model="codigoExternoClienteAgrupador"
            />
          </div>                  
        </div>

        <div class="informacoes-adicionais-titulo titulo-grupo-formulario"> Informações Adicionais </div>
        <div class="grupo-dados-info-adicionais">
          <div class="dados-exigencia-nota">
            <div class="titulo-conteudo-filtros"> Cliente possui alguma exigência na nota fiscal? </div>
            <div class="checkbox-filtros">
              <div class="input-checkbox">
                <PCheckBox 
                name="OrdComp"  
                v-model="OrdemCompra" 
                :binary="true"
                ></PCheckBox>
                <label class="label-checkbox"> Ordem de Compra </label>
              </div>
              
              <div class="input-checkbox">
                <PCheckBox 
                name="CodEspec" 
                v-model="CodigoEspecifico"
                :binary="true"
                ></PCheckBox>
                <label class="label-checkbox"> Código específico </label>
              </div>
            </div>
          </div>

          <div class="dados-observacoes">
            <div class="titulo-conteudo-filtros"> Observações </div>
            <div class="textarea-container">
              <PTextArea
              name="observacoes"
              v-model="DescricaoObservacao"
              placeholder="Digite aqui as observações"
              :autoResize="true"
              maxlength="1000" 
              ></PTextArea>
            </div>
          </div>
        </div>
      </div>

      <div class="buttons-next-back">
        <div class="button-next">
          <g-button
          tipo="amarelo" 
          negritoTexto 
          altura="35px"
          largura="100%"
          @click="gravar" 
          :disabled = "desabilitaGravar"
          >
            <div v-if="escritobotao"> GRAVAR </div>
            <div v-if="!escritobotao" class="pi pi-spin pi-spinner"></div>
          </g-button>
        </div>

        <div class="button-back">
          <g-button 
          tipo="cinza" 
          altura="35px"
          largura="100%"
          negritoTexto 
          v-on:acao="limpar" 
          >
            LIMPAR
          </g-button>
        </div>
      </div>
    </g-card>
  </div>

  <PDialog :closable="false" v-model:visible="popupFichaCadastral" :modal="true">
    <template #header>
      <div class="titulo-imagem-popup">
        <div class="imagem-popup">
          <img src="@/assets/imgs/icone_atencao.svg"/>
        </div>
        <div class="titulo-popup titulo-popup-ficha"> Cadastro exclusivo de clientes para faturamento! </div>
        <div class="subtitulo-popup subtitulo-popup-ficha"> Para gerar uma solicitação de orçamento, favor cadastrar o cliente como "Em Desenvolvimento". </div>
      </div>
    </template>

    <div class="botoes-popup button-popup">
        <div>
          <g-button
          negritoTexto
          tipo="cinza"
          altura="35px"
          largura="250px"
          @click="cadastrarClienteEmDesenvolvimento"
          >
          EM DESENVOLVIMENTO
          </g-button>
        </div>

        <div>
          <g-button
            negritoTexto
            altura="35px"
            largura="250px"
            @click="fechapopup"
          >
          CONTINUAR
          </g-button>
        </div>
      </div>
  </PDialog>


  <PDialog :closable="false" v-model:visible="popupFichaCadastralCliente" :modal="true">
    <div class="titulo-popup-finalizado"> Cliente cadastrado com sucesso! </div>
    <div class="botoes-popup">
      <div>
        <g-button
        tipo="cinza"
        negritoTexto 
        largura="200px" 
        altura="35px" 
        @click="consultarCliente"
        >
         CONSULTAR
        </g-button>
      </div>
      <div>
        <g-button
        negritoTexto
        largura="200px" 
        altura="35px" 
        @click="novoCliente"
        >
          NOVO CLIENTE
        </g-button>
      </div>
    </div>
  </PDialog>

  <cnpj-existente
      :emDesenvolvimento="this.situacaoVindaDoBanco"
      :visivel="popupjaexiste"
      v-on:cancelarcadastrocnpj="cancelarcadastrarcnpj"
      v-on:editarcnpjexistente="editarCnpjExistente">
  </cnpj-existente>
</template>

<script>
import Cliente from "./ClienteFichCada.js";

export default Cliente;
</script>

<style scoped>
.dados-telefone-celular{
  grid-area: 11 / 1/ 11 / 3;
  z-index: 3;

}

:deep(.custom-header) {
  padding-right: 10px;
}

.image-button {
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  width: 22em;
}

.image-container {
  /* Estilos para o container das imagens */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.image-wrapper {
  /* Estilos para cada wrapper de imagem e botão */
  margin: 10px;
  text-align: center;
}
.imageStyle {
  width: 400px;
}

.grid-cliente-contato {
  margin-top: 40px;
  border-top: 1px solid #f0f0f0;
}

.informacoes-adicionais-titulo {
  margin-top: 30px;
}

.grupo-form-contato {
  margin-top: 20px;
}

.button-popup-telefone {
  margin: 50px 0 15px;
}

@media (min-width: 310px) {
.checkbox-exterior-ie {
  display: flex;
  column-gap: 10px;
}
.buttons-arquivos { 
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 10px;
  margin: 10px 0; 
}

.titulo-imagem-popup {
  display: grid;
  grid-template-columns: 12em;
  grid-template-rows: repeat(3, auto);
}

.imagem-popup { grid-area: 1 / 1 / 2 / 3; text-align: center; }
.titulo-popup-ficha { grid-area: 2 / 1 / 3 / 3; text-align: center; }
.subtitulo-popup-ficha { grid-area: 3 / 1 / 4 / 3; text-align: center; }

.popup-mensagem-aviso {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  color: #4e4e4e;
  font-weight: 600;
  font-family: "MontSerrat";
  }
}

@media (min-width:368px) {
}

@media (min-width: 450px) {
  
.dados-suframa-inscricao {
  display: flex;
  flex-direction: row;
  column-gap: 30px;
}
.grupo-dados-cadastrais {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(14, auto);
  grid-column-gap: 20px;
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 2 / 1 / 3 / 2; }
.dados-inscricao { grid-area: 2 / 2 / 3 / 3; }
.dados-razao-social { grid-area: 3 / 1 / 4 / 3; }
.dados-nome-fantasia { grid-area: 4 / 1 / 5 / 3; }
.dados-segmento { grid-area: 5 / 1 / 6 / 2; }
.dados-curva-cliente { grid-area: 5 / 2 / 6 / 3; }
.dados-potencial-cliente { grid-area: 6 / 1 / 7 / 2; }
.dados-perfil-material { grid-area: 6 / 2 / 7 / 3; }
.dados-cep { grid-area: 7 / 1 / 8 / 2; }
.dados-estado { grid-area: 7 / 2 / 8 / 3; }
.dados-cidade { grid-area: 8 / 1 / 9 / 3; }
.dados-bairro { grid-area: 9 / 1 / 10 / 2; }
.dados-endereco { grid-area: 9 / 2 / 10 / 3; }
.dados-complemento { grid-area: 10 / 1 / 11 / 3; }
.dados-suframa-inscricao { grid-area: 11 / 1 / 12 / 3; }
.dados-incentivos { grid-area: 12 / 1 / 13 / 3; }
.buttons-arquivos { grid-area: 13 / 1 / 14 / 3; }
.dados-email { grid-area: 14 / 1 / 15 / 3; }
}

@media (min-width:500px) {
.grupo-dados-cadastrais {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(12, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 5; }
.dados-cnpj { grid-area: 2 / 1 / 3 / 3; }
.dados-inscricao { grid-area: 2 / 3 / 3 / 5; }
.dados-razao-social { grid-area: 3 / 1 / 4 / 5; }
.dados-nome-fantasia { grid-area: 4 / 1 / 5 / 3; }
.dados-segmento { grid-area: 4 / 3 / 5 / 5; }
.dados-curva-cliente { grid-area: 5 / 1 / 6 / 3; }
.dados-potencial-cliente { grid-area: 5 / 3 / 6 / 5; }
.dados-perfil-material { grid-area: 6 / 1 / 7 / 3; }
.dados-cep { grid-area: 6 / 3 / 7 / 4; }
.dados-estado { grid-area: 6 / 4 / 7 / 5; }
.dados-cidade { grid-area: 7 / 1 / 8 / 3; }
.dados-bairro { grid-area: 7 / 3 / 8 / 5; }
.dados-endereco { grid-area: 8 / 1 / 9 / 3; }
.dados-complemento { grid-area: 8 / 3 / 9 / 5; }
.dados-suframa-inscricao { grid-area: 9 / 1 / 10 / 5; }
.dados-incentivos { grid-area: 10 / 1 / 11 / 5; }
.buttons-arquivos { grid-area: 11 / 1 / 12 / 5; }
.dados-email { grid-area: 12 / 1 / 13 / 4; }
}

@media (min-width: 600px) {
.dados-codigo-cliente {
  width: 50%;
}
}

@media (min-width: 650px) {
.titulo-imagem-popup {
  grid-template-columns: 6em 26em;
  grid-template-rows: repeat(2, auto);
}

.imagem-popup {
  grid-area: 1 / 1 / 3 / 2;
  text-align: left;
  justify-self: self-start;
  align-self: center;
}
.titulo-popup-ficha {
  grid-area: 1 / 2 / 2 /3 ;
  text-align: left;
}
.subtitulo-popup-ficha {
  grid-area: 2 / 2 / 3 / 3;
  text-align: left;
}

.button-popup {
  flex-direction: row;
}
}

@media (min-width: 730px) {
.grupo-dados-cliente-agrupador {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: 20px;
}

.dados-empresa-cliente, .dados-nome-cliente {
  width: 20em;
}

.dados-codigo-cliente {
  width: 12em;
}
}

@media (min-width: 801px) {

.grupo-dados-cadastrais {
  grid-template-rows: repeat(11, auto);
}

.dados-unidade { grid-area: 1 / 1 / 2 / 3; }
.dados-cnpj { grid-area: 1 / 3 / 2 / 5; }
.dados-inscricao { grid-area: 2 / 1 / 3 / 3; }
.dados-razao-social { grid-area: 2 / 3 / 3 / 5; }
.dados-nome-fantasia { grid-area: 3 / 1 / 4 / 3; }
.dados-segmento { grid-area: 3 / 3 / 4 / 5; }
.dados-curva-cliente { grid-area: 4 / 1 / 5 / 3; }
.dados-potencial-cliente { grid-area: 4 / 3 / 5 / 5; }
.dados-perfil-material { grid-area: 5 / 1 / 6 / 3; }
.dados-cep { grid-area: 5 / 3 / 6 / 4; }
.dados-estado { grid-area: 5 / 4 / 6 / 5; }
.dados-cidade { grid-area: 6 / 1 / 7 / 3; }
.dados-bairro { grid-area: 6 / 3 / 7 / 5; }
.dados-endereco { grid-area: 7 / 1 / 8 / 3; }
.dados-complemento { grid-area: 7 / 3 / 8 / 5; }
.dados-suframa-inscricao { grid-area: 8 / 1 / 9 / 5; }
.dados-incentivos { grid-area: 9 / 1 / 10 / 5; }
.buttons-arquivos { grid-area: 10 / 1 / 11 / 5; }
.dados-email { grid-area: 11 / 1 / 12 / 3; }

.grupo-form-contato {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(9, auto);
  grid-column-gap: 20px;
}

.popup-tipo-contato { grid-area: 1 / 1 / 2 / 2; }
.popup-nome-contato { grid-area: 1 / 2 / 2 / 3; }
.popup-funcao-contato { grid-area: 2 / 1 / 3 / 2; }
.popup-sequencia { grid-area: 2 / 2 / 3 / 3; }
.linha1 { grid-area: 3 / 1 / 4 / 3; }
.popup-site { grid-area: 4 / 1 / 5 / 2; }
.popup-email { grid-area: 4 / 2 / 5 / 3; }
.linha2 { grid-area: 5 / 1 / 6 / 3; }
.popup-telefone { grid-area: 6 / 1 / 7 / 2; }
.popup-celular { grid-area: 6 / 2 / 7 / 3; }
.popup-telefone-exterior { grid-area: 7 / 1 / 8 / 2; }
.popup-celular-exterior { grid-area: 7 / 2 / 8 / 3; }
.linha3 { grid-area: 8 / 1 / 9 / 3; }
.popup-exigencia-nota { grid-area: 9 / 1 / 10 / 3; }


.dados-telefone-celular{
  grid-area: 11 / 3/ 12 / 5;
}
}

@media (min-width: 1025px) {
.grupo-dados-cadastrais {
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(9, auto);
}

.dados-inscricao { grid-area: 1 / 5 / 2 / 7; }
.dados-razao-social { grid-area: 2 / 1 / 3 / 3; }
.dados-nome-fantasia { grid-area: 2 / 3 / 3 / 5; }
.dados-segmento { grid-area: 2 / 5 / 3 / 7; }
.dados-curva-cliente { grid-area: 3 / 1 / 4 / 3; }
.dados-potencial-cliente { grid-area: 3 / 3 / 4 / 5; }
.dados-perfil-material { grid-area: 3 / 5 / 4 / 7; }
.dados-cep { grid-area: 4 / 1 / 5 / 2; }
.dados-estado { grid-area: 4 / 2 / 5 / 3; }
.dados-cidade { grid-area: 4 / 3 / 5 / 5; }
.dados-bairro { grid-area: 4 / 5 / 5 / 7; }
.dados-endereco { grid-area: 5 / 1 / 6 / 3; }
.dados-complemento { grid-area: 5 / 3 / 6 / 5; }
.dados-suframa-inscricao { grid-area: 6 / 1 / 7 / 7; }
.dados-incentivos { grid-area: 7 / 1 / 8 / 7; }
.buttons-arquivos { grid-area: 8 / 1 / 9 / 7; }
.dados-email { grid-area: 9 / 1 / 10 / 3; }

.dados-telefone-celular{
  grid-area: 5 / 5 / 12 / 7;
}
}

@media (min-width: 1281px) {
.grupo-form-contato {
  grid-template-columns: repeat(3, 1fr);
}

.popup-tipo-contato { grid-area: 1 / 1 / 2 / 2; }
.popup-nome-contato { grid-area: 1 / 2 / 2 / 3; }
.popup-funcao-contato { grid-area: 1 / 3 / 2 / 4; }
.popup-sequencia { grid-area: 2 / 1 / 3 / 2; }
.linha1 { grid-area: 3 / 1 / 4 / 4; }
.popup-site { grid-area: 4 / 1 / 5 / 2; }
.popup-email { grid-area: 4 / 2 / 5 / 3; }
.linha2 { grid-area: 5 / 1 / 6 / 4; }
.popup-telefone { grid-area: 6 / 1 / 7 / 2; }
.popup-celular { grid-area: 6 / 2 / 7 / 3; }
.popup-telefone-exterior { grid-area: 7 / 1 / 8 / 2; }
.popup-celular-exterior { grid-area: 7 / 2 / 8 / 3; }
.linha3 { grid-area: 8 / 1 / 9 / 4; }
.popup-exigencia-nota { grid-area: 9 / 1 / 10 / 4; }

.grupo-dados-cadastrais {
  grid-template-rows: repeat(8, auto);
}
.dados-suframa-inscricao { grid-area: 5 / 5 / 6 / 7; }
.dados-incentivos { grid-area: 6 / 1 / 7 / 7; }
.buttons-arquivos { grid-area: 7 / 1 / 8 / 7; }
.dados-email { grid-area: 8 / 1 / 9 / 3; }

.dados-telefone-celular{
  grid-area: 5 / 5 / 12 / 7;
}
}

@media (min-width:1500px) {
.grupo-dados-cadastrais {
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(7, auto);
}

.dados-razao-social { grid-area: 1 / 7 / 2 / 9; }
.dados-nome-fantasia { grid-area: 2 / 1 / 3 / 3; }
.dados-segmento { grid-area: 2 / 3 / 3 / 5; }
.dados-curva-cliente { grid-area: 2 / 5 / 3 / 7; }
.dados-potencial-cliente { grid-area: 2 / 7 / 3 / 9; }
.dados-perfil-material { grid-area: 3 / 1 / 4 / 3; }
.dados-cep { grid-area: 3 / 3 / 4 / 4; }
.dados-estado { grid-area: 3 / 4 / 4 / 5; }
.dados-cidade { grid-area: 3 / 5 / 4 / 7; }
.dados-bairro { grid-area: 3 / 7 / 4 / 9; }
.dados-endereco { grid-area: 4 / 1 / 5 / 3; }
.dados-complemento { grid-area: 4 / 3 / 5 / 5; }
.dados-suframa-inscricao { grid-area: 4 / 7 / 5 / 9; }
.dados-incentivos { grid-area: 5 / 1 / 6 / 9; }
.buttons-arquivos { grid-area: 6 / 1 / 7 / 9; }
.dados-email { grid-area: 7 / 1 / 8 / 3; }


.dados-telefone-celular{
  grid-area: 4 / 5 / 12 / 7;
}

}
</style>